const getCardHeader = (title) => {
  return (
    <div className="card-header bg-primary text-white">
      <h5>{title}</h5>
    </div>
  );
};
export default getCardHeader;
